<template>
  <v-dialog
    v-model="value"
    max-width="500px"
    @click:outside="close"
    @keydown.esc="close"
    persistent
  >
    <v-card>
      <v-card-text
        style="padding: 0; margin: 0;height:800px;
  position: relative;"
      >
        <header class="diag-title">신규 등록</header>
        <div class="add-body">
          <div>
            <CustomInputTextForm
              :error-form="
                clientCompNameRedundancyMsg
                  ? clientCompNameRedundancyMsg.includes('입력하신')
                  : false
              "
              validity="comp-name-redundancy"
              title="고객사명"
              placeholder="고객사명을 입력하세요."
              @click="checkRedundancy()"
              :infoFontSmall="true"
              :needCheck="true"
              @set="
                $event => {
                  clientCompName = $event.val;

                  clientCompCheck = false;

                  clientCompNameRedundancyMsg = '';
                }
              "
            />
            <div
              v-if="clientCompNameRedundancyMsg"
              :style="
                `${
                  clientCompNameRedundancyMsg.includes('확인')
                    ? 'color: var(--primary-100)'
                    : 'color: var(--error-100)'
                };font-size:12px;margin-top:8px`
              "
            >
              {{ clientCompNameRedundancyMsg }}
            </div>
            <div style="height:24px;" />
            <CustomInputTextForm
              validity="phone"
              title="전화번호"
              :infoFontSmall="true"
              placeholder="‘-’를 포함하여 입력하세요."
              @set="
                $event => {
                  phone = $event.val;
                  phoneCheck = $event.res;
                }
              "
            />

            <div class="title-input">구분</div>
            <Dropdown
              style="align-self: center"
              v-if="value"
              v-model="selectedKind"
              icon-size="24px"
              icon-margin="24px"
              pad="0 24px"
              :items="kindList"
              width="100%"
              height="56px"
              border="1px solid var(--gray-300)"
              @change="
                $event => {
                  this.kindType = $event;
                }
              "
            ></Dropdown>
            <div class="title-input">구매형태</div>
            <div style="display: flex">
              <button
                :class="
                  purchaseType === '솔루션'
                    ? 'client-generic-button-left--checked'
                    : 'client-generic-button-left'
                "
                @click="purchaseType = '솔루션'"
              >
                솔루션
              </button>
              <button
                :class="
                  purchaseType === 'API'
                    ? 'client-generic-button-right--checked'
                    : 'client-generic-button-right'
                "
                @click="purchaseType = 'API'"
              >
                API
              </button>
            </div>
            <div class="title-input">활성여부</div>
            <div style="display: flex">
              <button
                :class="
                  isActivated === '활성'
                    ? 'client-generic-button-left--checked'
                    : 'client-generic-button-left'
                "
                @click="isActivated = '활성'"
              >
                활성
              </button>
              <button
                :class="
                  isActivated === '비활성'
                    ? 'client-generic-button-right--checked'
                    : 'client-generic-button-right'
                "
                @click="isActivated = '비활성'"
              >
                비활성
              </button>
            </div>
            <div style="height:40px" />
          </div>
        </div>
        <div style="border-top:1px solid var(--gray-100); ">
          <div class="button-container">
            <div v-ripple @click="close" class="button cancel">취소</div>
            <div
              v-if="
                clientCompName != '' &&
                  clientCompCheck &&
                  phoneCheck &&
                  purchaseType != '선택' &&
                  selectedKind != '' &&
                  selectedKind != '선택' &&
                  isActivated != ''
              "
              v-ripple
              @click="register"
              class="button ok"
            >
              등록
            </div>
            <div v-else class="button default" style="cursor: unset">등록</div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Dropdown from '@/components/Dropdown.vue';
// import DropdownDialog from "@/components/root/dialog/DropDownComponent.vue";
import CustomInputTextForm from '@/components/CustomInputTextForm.vue';
export default {
  components: { Dropdown, CustomInputTextForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
    },
  },
  data() {
    return {
      registerList: ['API', '솔루션'],
      kindList: ['선택', '비금융권', '금융권', '가상자산사업자', 'P2P온투업자'],
      phone: '',
      phoneCheck: false,
      clientCompName: '',
      clientCompCheck: false,
      clientCompNameRedundancyMsg: '',
      purchaseType: '선택',
      selectedKind: '선택',
      isActivated: '',
    };
  },
  methods: {
    async close() {
      //initialize
      this.clientCompName = '';
      this.clientCompRedundancyCheckCount = 0;
      this.clientCompRedundancyErrFlag = false;
      this.purchaseType = '';
      this.selectedKind = '';
      this.isActivated = '';
      await this.$store.dispatch('getClientList', {
        //start: 0,
        //count: 20,
        start: 0,
        name: '',
      });
      this.$emit('close');
    },
    async register() {
      this.$log.debug(this.purchaseType);
      this.$log.debug(this.checkRedundancy());
      await this.$store.dispatch('registerClient', {
        name: this.clientCompName,
        industry: this.kindList.indexOf(this.selectedKind) + 1,
        purchase_type: this.registerList.indexOf(this.purchaseType),
        active: this.isActivated == '활성' ? true : false,
        phone_number: this.phone,
      });
      this.$store.dispatch('showRegistrationSnackbar', {
        message: '고객사 등록이 완료되었습니다.',
      });
      this.close();
    },
    async checkRedundancy() {
      var res = await this.$store.dispatch('checkCompName', {
        customer_name: this.clientCompName,
      });
      this.$log.debug('ModifyDialog#checkRedundancy', res);
      if (!res.result) {
        this.clientCompCheck = true;
        this.clientCompNameRedundancyMsg = '확인되었습니다.';
      } else {
        this.clientCompCheck = false;
        this.clientCompNameRedundancyMsg =
          '입력하신 고객사명이 이미 존재 합니다.';
      }
      this.$log.debug('ModifyDialog#checkRedundancy', this.clientCompNameCheck);
    },
  },
};
</script>

<style lang="scss" scoped>
.client-comp-name,
.client-comp-name--fail,
.client-generic-button-left,
.client-generic-button-right,
.client-generic-button-left--checked,
.client-generic-button-right--checked,
.client-comp-name--redundancy,
.activation-check {
  outline: none;
}
.diag-title {
  padding: 8% 0 4% 8%;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: var(--surface-high);
}
.add-body {
  display: flex;
  flex-direction: column;
  margin: 0 8% 0 8%;
  max-height: 592px;
  overflow: scroll;
}

.title-input {
  margin: 44px 0 8px 0;
}
.client-comp-name {
  height: 56px;
  width: 70%;
  border: 1px solid var(--gray-300);
  border-radius: 8px;
  padding: 0 16px;
  font-size: 16px;
  caret-color: var(--primary-80);
  &--redundancy {
    width: 27%;
    margin-left: 3%;
    color: var(--surface-100);
    background: var(--surface-medium);
    border-radius: 8px;
  }
  &--fail {
    height: 56px;
    border-radius: 8px;
    padding: 0 16px;
    font-size: 16px;
    border: 1px solid red;
    width: 70%;
    caret-color: red;
  }
}
.client-comp-name:focus,
.client-comp-name--fail:focus {
  outline: none;
}
.client-generic-button-left {
  width: 50%;
  height: 56px;
  color: var(--surface-medium);
  background: var(--surface-100);
  border: 1px solid var(--gray-300);
  border-radius: 8px 0 0 8px;
  &--checked {
    width: 50%;
    height: 56px;
    color: var(--surface-medium);
    border: 2px solid var(--primary-80);
    border-radius: 8px 0 0 8px;
    background: var(--surface-100);
  }
}
.client-generic-button-right {
  width: 50%;
  height: 56px;
  color: var(--surface-medium);
  background: var(--surface-100);
  border: 1px solid var(--gray-300);
  border-radius: 0 8px 8px 0;
  &--checked {
    width: 50%;
    height: 56px;
    color: var(--surface-medium);
    background: var(--surface-100);
    border: 2px solid var(--primary-80);
    border-radius: 0 8px 8px 0;
  }
}

.button-container {
  position: absolute;
  margin: 0 8% 0 8%;
  bottom: 0;
  display: flex;
  width: 84%;
  padding: 2% 0 8% 0;
  .default {
    width: 60%;
    color: var(--surface-100);
    background: var(--primary-20);
  }
  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-weight: 500;
    font-size: 20px;
    height: 60px;
    cursor: pointer;

    &.cancel {
      width: 40%;
      color: var(--surface-medium);
      margin-right: 9px;
      background: var(--gray-100);
    }

    &.ok {
      width: 60%;
      color: var(--surface-100);
      background: var(--primary-100);
    }
  }
}
</style>
